// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PlpPatientGetEnrollmentsGetEnrollmentsResponse {
    static getAttributeTypeMap() {
        return PlpPatientGetEnrollmentsGetEnrollmentsResponse.attributeTypeMap;
    }
}
PlpPatientGetEnrollmentsGetEnrollmentsResponse.discriminator = undefined;
PlpPatientGetEnrollmentsGetEnrollmentsResponse.additionalProperties = false;
PlpPatientGetEnrollmentsGetEnrollmentsResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "EnrollmentHybridPatientSearchResultModel"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=plpPatientGetEnrollmentsGetEnrollmentsResponse.js.map